import { IProductItem } from '../types/homeTypes';

export const mapProductToCartItemData = (
  product: IProductItem,
  isBigMenuImageUsed: boolean,
  currencySymbol: string,
): IProductItem => {
  return {
    ...product,
    id: product.id,
    cost: product.price,
    currency: currencySymbol,
    title: product.name,
    thumbImageUrl: product.thumbImage || product.image,
    imageUrl: product.image,
    description: product.description,
    tags: product.tags,
    altName: product.altName,
    active: product.active,
    shortName: product.shortName,
    groups: product.groups.filter((group) => !group.hideForWeb),
  };
};

export const formatDataTag = (tag: string) => {
  const temp = tag.replace(/_/g, ' ').toLowerCase();
  return temp.charAt(0).toUpperCase() + temp.slice(1);
};

export const getHomeSliderSetting = () => {
  return {
    dots: false,
    infinite: true,
    row: 1,
    speed: 300,
    slidesToShow: 10,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 660,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
        },
      },
    ],
  };
};
